import { render } from "./NotificationsSettings.vue?vue&type=template&id=791f19c3&scoped=true"
import script from "./NotificationsSettings.vue?vue&type=script&lang=js"
export * from "./NotificationsSettings.vue?vue&type=script&lang=js"

import "./NotificationsSettings.vue?vue&type=style&index=0&id=791f19c3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-791f19c3"]])

export default __exports__